import intlTelInput from 'intl-tel-input';
export default class PhoneInput {
    constructor(container) {
        this.container = container;
        this.element = container.querySelector('input[type="tel"]');
        if (!this.element) {
            return;
        }
        this.init();
    }
    init() {
        var _a, _b, _c, _d, _e, _f;
        const hiddenInput = this.container.querySelector(`[name="${this.element.name}_code"]`);
        const existingDialCode = (_a = hiddenInput === null || hiddenInput === void 0 ? void 0 : hiddenInput.value) === null || _a === void 0 ? void 0 : _a.replace('+', '');
        let initialCountry = ((_c = (_b = window.localize_script) === null || _b === void 0 ? void 0 : _b.country) === null || _c === void 0 ? void 0 : _c.toLowerCase()) || 'lv';
        if (existingDialCode) {
            const countryData = intlTelInput.getCountryData();
            const country = countryData.find((country) => country.dialCode === existingDialCode);
            initialCountry = country ? country.iso2 : (((_e = (_d = window.localize_script) === null || _d === void 0 ? void 0 : _d.country) === null || _e === void 0 ? void 0 : _e.toLowerCase()) || 'lv');
        }
        this.instance = intlTelInput(this.element, {
            initialCountry: initialCountry,
            separateDialCode: true,
            formatOnDisplay: true,
        });
        const updateDialCode = () => {
            if (!this.instance) {
                return;
            }
            const countryData = this.instance.getSelectedCountryData();
            if (!countryData) {
                return;
            }
            if (hiddenInput) {
                hiddenInput.value = `+${countryData.dialCode}`;
            }
        };
        this.element.addEventListener('countrychange', updateDialCode);
        this.element.addEventListener('input', updateDialCode);
        (_f = this.element.form) === null || _f === void 0 ? void 0 : _f.addEventListener('submit', updateDialCode);
        if (!(hiddenInput === null || hiddenInput === void 0 ? void 0 : hiddenInput.value)) {
            updateDialCode();
        }
    }
    getCountryByDialCode(dialCode) {
        var _a;
        const countryData = (_a = this.instance) === null || _a === void 0 ? void 0 : _a.getCountryData();
        if (!countryData) {
            return window.localize_script.country.toLowerCase();
        }
        const country = countryData.find((country) => country.dialCode === dialCode);
        return country ? country.iso2 : window.localize_script.country.toLowerCase();
    }
}
